// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table td.regist_type,\n.el-table th.regist_type {\n  width: 6em;\n}\n.el-table i.el-icon-check {\n  font-size: 1.3em;\n}", ""]);
// Exports
module.exports = exports;
